import { ComponentType } from 'react';
import {
  PlanningEntityMap,
  Event
} from 'components/roster-portal/activity-planning/types';
import {
  PlanningEntityType,
  PlanningTaskCategoryResponse,
  PlanningTaskTypeResponse,
  ScheduleResponse
} from 'generated/index';
import { ToPlanDropzoneProps } from 'components/roster-portal/activity-planning/components/InnerList/ToPlanDropzone.types';

export enum TaskListCategory {
  TO_PLAN_APPOINTMENTS = 'TO_PLAN_APPOINTMENTS',
  SCHEDULE_TO_ASSIGN = 'SCHEDULE_TO_ASSIGN',
  SCHEDULE_WITH_MULTIPLE_DUTIES = 'SCHEDULE_WITH_MULTIPLE_DUTIES'
  // URGENT = 'URGENT',
  // WARNINGS = 'WARNINGS'
}

/**
 * Minimal props interface shared by SortedToPlanList and SortedToPlanListPragmatic.
 * Used as the prop type for SortedToPlanListComponent in TaskListProps so both
 * implementations can be passed interchangeably.
 */
export interface SortedToPlanListBaseProps {
  activeEntityContainingSelection: string | null;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  readOnly?: boolean;
  events: Event[];
  onChangeMousePosition?: (pos: { x: number; y: number }) => void;
  onChangeActiveEntity?: (entityId: string) => void;
  onChangeSelection?: (selectionIds: string[]) => void;
  multiplePlanningEntitiesSelected?: boolean;
}

export interface TaskListProps {
  onOpen?: () => void;
  onClose?: () => void;
  planningEntities: PlanningEntityMap | null;
  dropzonePadding?: string;
  activeEntityContainingSelection: string | null;
  onChangeActiveEntity: (entityId: string) => void;
  onChangeSelection: (selectionIds: string[]) => void;
  onChangeMousePosition?: (pos: { x: number; y: number }) => void;
  onRouteClick?: (date: Date, routeId?: string) => void;
  isTimeline?: boolean;
  DropzoneComponent: ComponentType<ToPlanDropzoneProps>;
  SortedToPlanListComponent: ComponentType<SortedToPlanListBaseProps>;
}

export interface ScheduleTask {
  type?: PlanningTaskTypeResponse;
  category?: PlanningTaskCategoryResponse;
  data?: ScheduleResponse;
}

export type ScheduleTaskData = ScheduleResponse;

export interface RouteEntity {
  planningTasks: ScheduleTask[];
}
